import apiService from '@/services/apiService';

const actions = {
  getCorpSalesTestimonials({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/testimonial/find-with-paging', payload)
        .then((response) => {
          commit('getCorpSalesTestimonials', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCorpSalesTestimonial({ commit }, payload) {
    apiService.get(`corporate-sales/testimonial/${payload}`)
      .then((response) => {
        commit('getCorpSalesTestimonial', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateStatusCorpSalesTestimonial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/testimonial/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderCorpSalesTestimonial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`corporate-sales/testimonial/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postCorpSalesTestimonial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/testimonial', payload)
        .then((response) => {
          // commit('postCorpSalesTestimonial', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCorpSalesTestimonial({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`corporate-sales/testimonial/${payload.id}`, payload.formData)
        .then((response) => {
          // commit('putCorpSalesTestimonial', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delCorpSalesTestimonial({ commit }, payload) {
    apiService.delete(`corporate-sales/testimonial/${payload}`)
      .then((response) => {
        // commit('delCorpSalesTestimonial', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
